/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/async";
import { Typography } from "@mui/material";
import debounce from "lodash/debounce";

const DestinationPicker = ({
  handleChange = () => {},
  destination,
  setFieldValue = () => {},
  selectedDestination = {},
  isClearable = false,
  isUser = false,
}) => {
  const filterDestination = (data) =>
    data.map((destinationsData) => ({
      label: destinationsData?.destinationName,
      value: destinationsData?._id,
      type: destinationsData?.destinationType,
    }));

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      let url = `${process.env.REACT_APP_API}/destinations?`;
      url += `${inputValue && `&destinationName=${inputValue}`}`;
      url += "&sort=destinationName";
      url += "&dir=asc";
      setTimeout(() => {
        // resolve();
        fetch(url)
          .then((response) => response.json())
          .then((result) => {
            const filteredData = filterDestination(result.data);
            resolve(filteredData);
          })
          .catch((error) => console.log(error.message));
      }, 1000);
    });

  const debouncedLoadOptions = debounce((inputValue, callback) => {
    promiseOptions(inputValue)
      .then((options) => {
        callback(options);
      })
      .catch((error) => {
        console.error(error);
      });
  }, 1000); // Adjust the delay time (in milliseconds) as needed

  const getPlaceholder = () => {
    if (Array.isArray(selectedDestination)) {
      if (selectedDestination[0]?.label || selectedDestination[0] === null) {
        return selectedDestination[0].label;
      }
      return "Search for a Destination";
    }
    if (selectedDestination?.label || selectedDestination === null) {
      return selectedDestination.label;
    }
    return "Search for a Destination";
  };

  return (
    <div>
      <Typography style={{ wordBreak: "break-word", fontSize: "0.875rem", fontWeight: 400 }}>
        {destination.label}
      </Typography>{" "}
      <AsyncSelect
        // ref={selectRef}
        cacheOptions
        defaultOptions
        placeholder={getPlaceholder()}
        isClearable={isClearable}
        // key={destination}
        menuPosition="fixed"
        loadOptions={debouncedLoadOptions}
        onChange={(option, { action }) => {
          if (option) {
            handleChange(option);
            if (isUser) {
              setFieldValue("destinations", option);
              setFieldValue("locDestinations.destinations", option);
              setFieldValue("locDestinations.location", "");
              setFieldValue("location", "");
            } else setFieldValue("destination", option);
          }
          if (action === "clear") {
            handleChange(null);
            if (isUser) {
              setFieldValue("destinations", {});
              setFieldValue("locDestinations.destinations", {});
            } else setFieldValue("destination", {});
          }
        }}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
          LoadingIndicator: () => null,
        }}
        styles={{
          control: (base) => ({
            ...base,
            // border: "none!important",
            // boxShadow: "none",
            height: "40px",
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          input: (base) => ({
            ...base,
            fontSize: "0.875rem",
          }),
          // option: (base) => ({
          //   ...base,
          //   padding: "18px 18px", // Adjust the padding as needed
          // }),
          menuList: (base) => ({
            ...base,
            fontSize: "0.875rem",
          }),
          placeholder: (base) => ({
            ...base,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            // overflow: "hidden",
            maxWidth: "100%",
            WebkitLineClamp: 1,
            fontSize: "0.875rem",
          }),
          singleValue: (base) => ({
            ...base,
            fontSize: "0.875rem",
            overflow: "unset",
          }),
        }}
      />
    </div>
  );
};

DestinationPicker.propTypes = {
  destination: PropTypes.instanceOf(Object).isRequired,
  setFieldValue: PropTypes.func,
  handleChange: PropTypes.func,
  isClearable: PropTypes.bool,
  isUser: PropTypes.bool,
  selectedDestination: PropTypes.instanceOf(Object),
};

export default DestinationPicker;
